// Portal domain — magic-link auth, matter view, questions, translation, saved-doc helpers.
import { API, PORTAL_TOKEN_KEY, PORTAL_MATTER_KEY } from './_client';

export const portalDocs = {
  list: () => API.get('/documents/portal/list').then((r) => r.data),
  upload: (file, docType) => {
    const fd = new FormData();
    fd.append('file', file);
    if (docType) fd.append('doc_type', docType);
    return API.post('/documents/portal/upload', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data);
  },
  signDeclaration: (docId) => API.post(`/documents/portal/${docId}/sign-declaration`).then((r) => r.data),
};

export const portal = {
  requestMagic: (email, matter_ref) => API.post('/portal/magic/request', { email, matter_ref }).then((r) => r.data),
  verifyMagic: async (token) => {
    const { data } = await API.post('/portal/magic/verify', { token });
    localStorage.setItem(PORTAL_TOKEN_KEY, data.access_token);
    localStorage.setItem(PORTAL_MATTER_KEY, data.matter_ref);
    return data;
  },
  matter: () => API.get('/portal/matter').then((r) => r.data),
  pathway: () => API.get('/portal/pathway').then((r) => r.data),
  submitQuestion: (payload) => API.post('/portal/questions', payload).then((r) => r.data),
  listQuestions: () => API.get('/portal/questions').then((r) => r.data),
  translate: (target_language, strings) =>
    API.post('/portal/translate', { target_language, strings }).then((r) => r.data),
  logout() {
    localStorage.removeItem(PORTAL_TOKEN_KEY);
    localStorage.removeItem(PORTAL_MATTER_KEY);
  },
  isAuthed: () => !!localStorage.getItem(PORTAL_TOKEN_KEY),
};
